import * as React from 'react'
import classNames from 'classnames'
import { ILoaderImage } from './interface'
import './LoaderImage.scss'

const LoaderImage = ({ className, ...rest }: ILoaderImage): JSX.Element => {
  return <img className={classNames('LoaderImage', className)} {...rest} />
}

export default LoaderImage
